module.exports = __webpack_public_path__ + "static/img/banner_04.cb6cf5b5.png";